import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { ref } from 'vue';
import { setErrorNotification } from '~~/common/utils/helper';
import { AW_AX_CACHE_DEFAULT } from '~~/common/plugins/axios/awAxCache';
import type { ResponseData } from '~~/common/types/api';

type AuchanStores = ResponseData<'/api/v2/store/list', 'get'>;

// NOTE:
// GET /api/v2/petrol/list — swagger documents `openingHours` on
// PetrolModel, but the field is not present in the real response when it
// would be empty array. Covered here by the DeepPartial in ResponseData.
type AuchanPetrolStations = ResponseData<'/api/v2/petrol/list', 'get'>;

export const useStoresAndPetrolsStore = defineStore('storesAndPetrolsStore', () => {
  const nuxtApp = useNuxtApp();

  const stores = ref<AuchanStores>([]);
  const petrolStations = ref<AuchanPetrolStations>([]);

  function setAuchanStores (payload: AuchanStores) {
    stores.value = payload;
  }

  function setAuchanPetrolStations (payload: AuchanPetrolStations) {
    petrolStations.value = payload;
  }

  async function fetchAuchanStores () {
    const {
      $api,
      $logger,
    } = nuxtApp;

    try {
      const result = await $api.$get<AuchanStores>('store/list', { awAxCache: AW_AX_CACHE_DEFAULT });
      setAuchanStores(result);
    } catch (error) {
      $logger.error(error);
      setErrorNotification({ nuxtApp, error });
    }

  }

  async function fetchAuchanPetrolStations () {
    const {
      $api,
      $logger,
    } = nuxtApp;

    try {
      const result = await $api.$get<AuchanPetrolStations>('petrol/list', { awAxCache: AW_AX_CACHE_DEFAULT });
      setAuchanPetrolStations(result);
    } catch (error) {
      $logger.error(error);
      setErrorNotification({ nuxtApp, error });
    }
  }

  return {
    stores,
    petrolStations,
    fetchAuchanStores,
    fetchAuchanPetrolStations,
  };

});
